import {
  Button,
  Select,
  MenuItem,
  FormControl,
  Divider,
} from "@material-ui/core";
import React from "react";
import { BonusBreakdownContext } from "../../contexts/BonusBreakdownContext";
import { RuleItem } from "../../interfaces/RuleItem";

interface Props {
  bonusSources: string[];
  ruleItemKey: string;
  addOrUpdateBonusSources(bonusSourceKeys: string[]): void;
}

export default ({
  bonusSources,
  ruleItemKey,
  addOrUpdateBonusSources,
}: Props) => {
  const { ruleItems } = React.useContext(BonusBreakdownContext);
  const availableRuleItemKeys: string[] = ruleItems.map((item) => item.key);
  const sourcesChosen = bonusSources.filter((key: string) =>
    availableRuleItemKeys.includes(key)
  );

  const selectSourceForRuleItem = (event: any, index: number) => {
    const sources = sourcesChosen;
    sources[index] = event.target.value;
    addOrUpdateBonusSources([...sources]);
  };

  const addSource = () => {
    if (ruleItems.length < 1) {
      alert("Can't add bonus source if there are no sources.");
      return;
    }
    const sources = sourcesChosen;
    // TODO have default rulemodule to default to
    sources.push(ruleItems[0].key);
    addOrUpdateBonusSources([...sources]);
  };

  const removeSource = (index: number) => {
    const sources = sourcesChosen;
    sources.splice(index, 1);
    addOrUpdateBonusSources([...sources]);
  };

  const ruleItemsSelection = ruleItems
    .filter((item: RuleItem) => {
      return item.key !== ruleItemKey;
    })
    .map((ruleItem: RuleItem) => {
      return (
        <MenuItem value={ruleItem.key} key={`${ruleItem.key}-${ruleItemKey}`}>
          {ruleItem.name}
        </MenuItem>
      );
    });

  const selectBoxes = sourcesChosen
    .filter((source: string) => {
      return availableRuleItemKeys.includes(source);
    })
    .map((key: string, index: number) => {
      const addSourceButtonId = `add-bonus-source-button-${ruleItemKey}`;
      const selectSourceId = `select-attr-${ruleItemKey}`;
      return (
        <FormControl key={`select-attr-${ruleItemKey}-${index}`}>
          <Select
            variant="outlined"
            value={sourcesChosen[index]}
            onChange={(event) => selectSourceForRuleItem(event, index)}
            id={`${selectSourceId}-${index}`}
          >
            {ruleItemsSelection}
          </Select>
          <Button
            color="primary"
            variant="contained"
            data-test={addSourceButtonId}
            onClick={() => removeSource(index)}
          >
            Remove
          </Button>
        </FormControl>
      );
    });

  const addNewSourceId = `add-new-bonus-source-${ruleItemKey}`;
  return (
    <>
      {selectBoxes}
      <Divider />
      <Button
        color="primary"
        variant="contained"
        data-test={addNewSourceId}
        onClick={addSource}
      >
        Add New Source
      </Button>
    </>
  );
};
